import { Space } from '@sravni/react-design-system';

import { OrderedListItem } from './OrderedListItem';

interface OrderedListProps {
  items: Array<{ title?: string; subtitle?: string }>;
}

export const OrderedList = ({ items }: OrderedListProps) => {
  const listItems = items.map(({ title, subtitle }, index) => (
    <OrderedListItem
      key={title}
      orderIndex={index + 1}
      title={title}
      subtitle={subtitle}
    />
  ));

  return (
    <Space
      direction="vertical"
      size={16}
    >
      {listItems}
    </Space>
  );
};
